import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from 'images/Paycor-AppActivation.svg';
import './_styles.module.scss';
import { useTranslation } from 'react-i18next';
import { getTranslatedText } from 'utils/i18n';

const Header = () => {
	const { t } = useTranslation();
	return (
		<header-container id="nav-header">
			<header-row>
				<left-menu-section>
					<menu-logo>
						<NavLink to="/">
							<img className="content picture picture-default" src={logo} alt="logo" title={getTranslatedText(t, 'DeveloperPortal', 'Paycor Developer Portal')} />
						</NavLink>
					</menu-logo>
				</left-menu-section>
				<right-menu-section></right-menu-section>
			</header-row>
		</header-container>
	);
};
export default Header;
